export default __webpack_public_path__ + "static/media/myPhoto3.d536dece.jpg";